/**
 * Converts an ArrayBuffer or Uint8Array to a hex-encoded string
 */
export const bufferToHex = (buffer: ArrayBufferLike | Uint8Array) =>
  [...(buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer))]
    .map((x) => x.toString(16).padStart(2, '0'))
    .join('');
